import Icon from "@/components/Icon";
import { useState } from "react";

/**
 * carousel images video
 * @param video video src
 */
const CarouselVideo = ({ video }: { video: string }) => {
  const [videoShow, setVideoShow] = useState<boolean>(false);
  const [play, setPlay] = useState<boolean>(false);

  /**
   * video play event
   */
  const handleVideoPlay = () => {
    var video: any = document.getElementById("videoPlayer");
    video.play();
    setPlay(true);
    setVideoShow(true);
  };

  /**
   * video pause
   */
  const handleVideoPause = () => {
    var video: any = document.getElementById("videoPlayer");
    video.pause();
    setPlay(false);
    setVideoShow(false);
  };

  return (
    <>
      <div
        className={`absolute left-0 top-0 z-30 flex h-full w-full bg-stone-900 ${
          !videoShow ? "hidden" : ""
        }`}
      >
        <Icon
          name="close-white"
          size={16}
          title="icon input close"
          className="absolute right-6 top-4 z-10 cursor-pointer"
          onClick={handleVideoPause}
        />
        <video
          id="videoPlayer"
          controls
          controlsList="nodownload noremoteplayback"
          className="max-h-full w-full max-w-full"
        >
          <source src={video} type="video/webm" />
          Your browser does not support video
        </video>
      </div>

      <div
        className={`absolute left-[50%] top-[70%] z-30 ml-[-25px] mt-[-25px] h-[50px] w-[50px] cursor-pointer ${
          videoShow ? "hidden" : ""
        }`}
        style={{
          background: "url(/pointsmall/images/main-circles.png) 0 -55px no-repeat",
        }}
        onClick={handleVideoPlay}
      ></div>
    </>
  );
};

export default CarouselVideo;
